/**
 * Comparator for path in dot notation, ordering by it's parts alphabetically
 *
 * @param {string} a
 * @param {string} b
 *
 * @return {number}
 */
export var comparePaths = function (a, b) {
    var depthDiff = 0;
    var aAsArray = a.split('.');
    b.split('.').some(function (path, index) {
        if (path !== aAsArray[index]) {
            depthDiff = aAsArray[index].localeCompare(path, 'en');
            return true;
        }
        return false;
    });
    return depthDiff;
};
//# sourceMappingURL=comparePaths.js.map